<div class="title">
  <i class="fa-thin fa-file file fa-lg"></i>
  <h3 class="heading-4">Your documents are currently unavailable</h3>
</div>

<div class="content mb-12 mt-12">
  <p class="body large">
    If you purchased your plan under 24 hours ago, your documents might not have been added yet. Please come back later.
  </p>
  <p class="body large">You can also receive them by selecting ‘Email my plan documents’.</p>
  <p class="body large">
    For anything else, you can see our
    <a
      class="link-text large"
      href="https://www.domesticandgeneral.com/content/help-advice-section/faq"
      target="_blank"
      rel="noopener"
      >help and advice</a
    >.
  </p>
</div>

<app-button dataLabel="close" class="mt-24" (click)="dialogRef.close()"> Close </app-button>
<i class="fa-light fa-xmark cross" (click)="dialogRef.close()"> </i>
